import React from 'react';
import { Link } from 'react-router-dom';
import '../../styles/layout/SharedLayout.css';

interface SharedLayoutProps {
  children: React.ReactNode;
}

/**
 * SharedLayout component provides a layout for publicly shared content
 * with a minimal header and simplified footer
 */
const SharedLayout: React.FC<SharedLayoutProps> = ({ children }) => {
  return (
    <div className="shared-layout">
      <header className="shared-header">
        <div className="header-content">
          <Link to="/" className="brand-link">
            <div className="brand-logo">
              <span className="logo-star">✨</span>
              <span className="logo-text">Wisporia</span>
            </div>
          </Link>
          <div className="header-actions">
            <Link to="/login" className="header-button login-button">Log In</Link>
            <Link to="/signup" className="header-button signup-button">Sign Up</Link>
          </div>
        </div>
      </header>
      
      {/* Main Content */}
      <main className="shared-content">
        {children}
      </main>
      
      {/* Simplified footer - only copyright */}
      <footer className="shared-footer">
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Wisporia. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default SharedLayout; 